import {
  DISABLE_FLOW_FEATURE_KEY,
  FEATURES,
  INBOUND_ADDON_FEATURE_KEY,
  MARITAL_STATUS_FEATURE_KEY,
  OCR_FEATURE_KEY,
  OOREDOO_FEATURE_KEY,
  QATAR_AGE_RESTRICTION_FEATURE_KEY,
  QATAR_BOOKING_OFFER_FEATURE_KEY,
  QATAR_MOPH_FEATURE_KEY,
  TRAVEL_KIT_OFFER_FEATURE_KEY,
  VISITORS_INBOUND_DEFAULT_STATE_AGE_LOGIC,
} from '@/shared/constants/features.constants'
import { initializeApp } from 'firebase/app'
import {
  fetchAndActivate,
  getRemoteConfig,
  getValue,
  setCustomSignals,
} from 'firebase/remote-config'
import { defineStore } from 'pinia'

const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: 'fb-web-qic.firebaseapp.com',
  projectId: 'fb-web-qic',
  storageBucket: 'fb-web-qic.firebasestorage.app',
  messagingSenderId: '76324519272',
  appId: '1:76324519272:web:c57028814ebaf5048f2add',
  measurementId: 'G-WFKYGFJCF9',
}

export const useFeaturesStore = defineStore('featuresStore', {
  state: () => ({
    features: {} as Record<string, boolean>,
    isInboundAddonEnabled: false,
    isOcrEnabled: false,
    isOoredooEnabled: false,
    isMaritalStatusEnabled: false,
    isTravelKitOfferEnabled: false,
    isFlowDisabled: false,
    isQatarMophEnabled: false,
    isQatarBookingOfferEnabled: false,
    isQatarAgeRestrictionEnabled: false,
    isInboundDefaultStateAgeLogicEnabled: false,
  }),
  getters: {
    getFeatureValue:
      (state) =>
      (feature: string): boolean =>
        state.features[feature] || false,
  },
  actions: {
    async fetchRemoteConfig() {
      try {
        const app = initializeApp(FIREBASE_CONFIG)
        const remoteConfig = getRemoteConfig(app)
        remoteConfig.settings.minimumFetchIntervalMillis = 3600000

        try {
          await setCustomSignals(remoteConfig, {
            env: process.env.NODE_ENV === 'production' ? window.location.hostname : 'dev',
          })
        } catch (error) {
          console.error('Error setting custom signals:', error)
        }

        await fetchAndActivate(remoteConfig)
        FEATURES.forEach((feature: string) => {
          this.features[feature] = getValue(remoteConfig, feature).asBoolean()
        })
        this.setIsInboundAddonEnabled()
        this.setIsOcrEnabled()
        this.setIsOoredooEnabled()
        this.setIsMaritalStatusEnabled()
        this.setIsTravelKitOfferEnabled()
        this.setIsFlowDisabled()
        this.setIsQatarMophEnabled()
        this.setIsQatarBookingOfferEnabled()
        this.setIsQatarAgeRestrictionEnabled()
        this.setIsInboundDefaultStateAgeLogicEnabled()
      } catch (error) {
        console.error('Error loading Remote Config:', error)
      }
    },
    setIsInboundAddonEnabled() {
      this.isInboundAddonEnabled = this.getFeatureValue(INBOUND_ADDON_FEATURE_KEY) || false
    },
    setIsOcrEnabled() {
      this.isOcrEnabled = this.getFeatureValue(OCR_FEATURE_KEY) || false
    },
    setIsOoredooEnabled() {
      this.isOoredooEnabled = this.getFeatureValue(OOREDOO_FEATURE_KEY) || false
    },
    setIsMaritalStatusEnabled() {
      this.isMaritalStatusEnabled = this.getFeatureValue(MARITAL_STATUS_FEATURE_KEY) || false
    },
    setIsTravelKitOfferEnabled() {
      this.isTravelKitOfferEnabled = this.getFeatureValue(TRAVEL_KIT_OFFER_FEATURE_KEY) || false
    },
    setIsFlowDisabled() {
      this.isFlowDisabled = this.getFeatureValue(DISABLE_FLOW_FEATURE_KEY) || false
    },
    setIsQatarMophEnabled() {
      this.isQatarMophEnabled = this.getFeatureValue(QATAR_MOPH_FEATURE_KEY) || false
    },
    setIsQatarBookingOfferEnabled() {
      this.isQatarBookingOfferEnabled =
        this.getFeatureValue(QATAR_BOOKING_OFFER_FEATURE_KEY) || false
    },
    setIsQatarAgeRestrictionEnabled() {
      this.isQatarAgeRestrictionEnabled =
        this.getFeatureValue(QATAR_AGE_RESTRICTION_FEATURE_KEY) || false
    },
    setIsInboundDefaultStateAgeLogicEnabled() {
      this.isInboundDefaultStateAgeLogicEnabled =
        this.getFeatureValue(VISITORS_INBOUND_DEFAULT_STATE_AGE_LOGIC) || false
    },
  },
})
